import { FETCH_TRANSLATION_SUCCESS } from '../actionTypes';

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_TRANSLATION_SUCCESS:
      return payload;
    default:
      return state;
  }
};
